<!--
 * @Description: description
 * @Author: chenguobiao
 * @Date: 2021-12-21 21:11:52
 * @LastEditTime: 2022-10-10 23:04:27
 * @LastEditors: chenguobiao
-->
<template>
  <div class="dialog" v-if="visible">
    <div class="dialog__masker"></div>
    <div class="dialog__box">
      <!-- <div class="dialog__bg">
        <img src="@/render/assets/images/personal/dialog_bg.png">
      </div> -->
      <div class="dialog__desc">{{desc}}</div>
      <div class="dialog__options">
        <div class="option" v-if="showCancel" @click="cancel">取消</div>
        <div class="option" @click="confirm">确定</div>
      </div>
    </div>
  </div>
</template>

<script>
import dialogMixin from './mixin'
export default {
  mixins: [dialogMixin],
  props: {
    desc: {
      type: String,
      // require: true
    },
    showCancel: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style lang="scss" scoped>
  .dialog {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999;
    &__masker {
      position: absolute;
      width: 100%;
      height: 100%;
      background: #000;
      opacity: 0.5;
    }
    &__box {
      position: relative;
      width: val(400);
      height: val(200);
      background: url(../../assets/images/personal/dialog_bg02.png) left top no-repeat;
      background-size: 100%;
      z-index: 100;
    }
    &__desc {
      padding-top: val(88);
      text-align: center;
      line-height: val(24);
      font-size: val(18);
      color: #502700;
    }
    &__options {
      position: absolute;
      left: 50%;
      bottom: 0;
      transform: translateX(-50%);
      margin-bottom: val(-21);
      display: flex;
      justify-content: center;
      .option {
        width: val(120);
        line-height: val(42);
        border-radius: val(37);
        font-size: val(18);
        text-align: center;
        &:first-of-type {
          margin-right: val(30);
          color: #6A6A6A;
          background: linear-gradient(360deg, #8D8D8D 0%, #C1C1C1 56%, #E9E9E9 100%);
        }
        &:last-of-type {
          color: #fff;
          background: linear-gradient(360deg, #B26113 0%, #FDAE5F 100%);
        }
        
      }
    }
  }

</style>